import React from 'react';
import { Button } from 'antd';
import { ShoppingCartOutlined } from '@ant-design/icons';

import PriceTag from '../../../components/shared/PriceTag';

import {
  SavedSection,
  SavedTitle,
  SavedGrid,
  SavedCard,
  SavedCardInfo,
  SavedCardTitle,
  SavedCardAuthor,
  ItemImage,
} from '../styles';

export default function SavedForLater({ savedItems, onMoveToCart }) {
  if (!savedItems.length) return null;

  return (
    <SavedSection>
      <SavedTitle>Guardados para despues</SavedTitle>
      <SavedGrid>
        {savedItems.map((item) => (
          <SavedCard key={item.listingId}>
            <ItemImage>
              {item.coverImage && <img src={item.coverImage} alt={item.bookTitle} />}
            </ItemImage>
            <SavedCardInfo>
              <SavedCardTitle to={`/libro/${item.listingId}`}>{item.bookTitle}</SavedCardTitle>
              <SavedCardAuthor>{item.authorName}</SavedCardAuthor>
              <PriceTag amount={item.price} originalAmount={item.originalPrice} />
              <Button
                type="default"
                size="small"
                icon={<ShoppingCartOutlined />}
                style={{ marginTop: 8, alignSelf: 'flex-start' }}
                onClick={() => onMoveToCart(item.listingId)}
              >
                Agregar al carrito
              </Button>
            </SavedCardInfo>
          </SavedCard>
        ))}
      </SavedGrid>
    </SavedSection>
  );
}
